export const ROUTES_TOYOTA = ["toyota", "trim", "powertrain", "exteriorcolor", "interiorColor", "packages", "zipcode", "findMyCar"]
  